<template>
  <div class="devicontent">
    <div style="display: flex">
      <Headbuttom></Headbuttom>

      <div class="dei_rowp" slot="headerButtom">
        <el-button type="primary" class="but" size="small" @click="handAdddevi">
          <i class="el-icon-plus"></i>
          {{ $i18n.t("navLeft.add") }}
        </el-button>
        <div @click="handFromshow">
          <el-input
            size="small"
            class="dev_dowm"
            placeholder=""
            suffix-icon="el-icon-arrow-down"
            :readonly="true"
          >
          </el-input>
        </div>
      </div>
    </div>

    <transition
      enter-active-class="animated fadeInDown"
      leave-active-class="animated fadeOutUp"
    >
      <div class="frominput" v-if="flag">
        <el-form
          :inline="true"
          size="small"
          :model="formInline"
          class="demo-form-inline"
        >
          <el-form-item :label="$t('devtable.sbmc')">
            <el-input
              v-model="formInline.name"
              :placeholder="$t('devtable.sbmc')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('devtable.sbxlh')">
            <el-input
              v-model="formInline.serial_number"
              :placeholder="$t('devtable.sbxlh')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('devtable.sbzt')">
            <el-select v-model="formInline.device_state" placeholder="">
              <el-option :label="$t('devtable.wxz')" value="-1"></el-option>
              <el-option :label="$t('devtable.lx')" value="0"></el-option>
              <el-option :label="$t('devtable.zx')" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('devtable.kmms')">
            <el-select v-model="formInline.lock_mode" placeholder="">
              <el-option :label="$t('devtable.wxz')" value="-1"></el-option>
              <el-option :label="$t('devtable.ysms')" value="0"></el-option>
              <el-option :label="$t('devtable.ckms')" value="1"></el-option>
              <el-option :label="$t('devtable.cbms')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item :label="$t('devtable.sfzcj')">
            <el-select v-model="formInline.is_registe" placeholder="">
              <el-option :label="$t('devtable.f')" value="0"></el-option>
              <el-option :label="$t('devtable.s')" value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="onSubmit">{{
              $t("devtable.cx")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </transition>
    <Tables
      @handlpages="handlpages"
      @handlerow="handlerow"
      @handleSizeChange="handleSizeChange"
      :tableData="tableData"
      :tableLabel="tableLabel"
      :operation="operation"
      :flags="flags"
      :configs="configs"
    ></Tables>
    <AuthtabdiolgEdit
		:diolg="diolgEdit"
        ref="deviceEdit"
    ></AuthtabdiolgEdit>
    <Maintainfrom @ ref="maintainfrom"></Maintainfrom>
    <Namefrom @handialogname="handialogname" ref="namefrom"></Namefrom>
	<Authtabdiolg :authtabdiolgdata="authtabdiolgdata" :diolg="diolg" ref="authtabdiolg"></Authtabdiolg>
  </div>
</template>
<script>
import Tables from "@/components/table";
import Deviadd from "./components/deviadd";
import Maintainfrom from "./components/maintainfrom";
import Authtabdiolg from './components/autl'
import AuthtabdiolgEdit from './components/autlEdit'
import methodlist from "../../utils/methods";
import Namefrom from "./components/namefrom";
import { mapState } from "vuex";
import {
  openDoor,
  clearDevice,
  updateDevice,
  resetDevice,
} from "../../mqtt/mqtt";

export default {
  components: {
    Tables,
    Deviadd,
    Maintainfrom,
    Namefrom,
	Authtabdiolg,
	AuthtabdiolgEdit
  },
  data() {
    return {
      flag: false,
	  diolg:false,
	  diolgEdit:false,
	  authtabdiolgdata:{},
      order_by: 0,
      tableData: [],

      flags: {
        show: false, // 多选是否显示
        ishow: false, // 序号是否显示
      },
      // 分页数据
      configs: {
        pagesize: 10,
        total: 200,
        loading: false, // 加载状态
      },
      // operation: ,

      titlename: "",

      formInline: {
        name: "",
        serial_number: "",
        device_state: "",
        lock_mode: "",
        factory: "",
        is_registe:''
      },
      UserInfo: "",
      lang: "",
      width: 120,
    };
  },
  computed: {
    ...mapState({
      langvalue: (state) => state.lang.langvalue,
    }),
    tableLabel: function () {
      return [
        {
          prop: "id",
          label: this.$t("devtable.mjzjbh"),
          align: "center",
          width: this.width,
        },
        {
          prop: "name",
          label: this.$t("devtable.mjjzmc"),
          align: "center",
          width: this.width,
        },
        {
          prop: "devices",
          label: this.$t("devtable.lyh"),
          align: "center",
          width: 796,
        },
      ];
    },
    operation: function () {
      return {
        width: 160,
        data: [
          {
            name: this.$t("devtable.xg"),
            type: "primary",
          },
          {
            name: this.$t("tablename.sc"),
            type: "danger",
          },
        ],
      };
    },
    most: function () {
      return {
        ysms: this.$t("devtable.ysms"),
        ckms: this.$t("devtable.ckms"),
        frlj: this.$t("devtable.frlj"),
        rlj: this.$t("devtable.rlj"),
        zx: this.$t("devtable.zx"),
        lx: this.$t("devtable.lx"),
        s: this.$t("devtable.s"),
        f: this.$t("devtable.f"),
        cbms: this.$t("devtable.cbms"),
        j: this.$t("devtable.j"),
        c: this.$t("devtable.c"),
      };
    },
  },
  watch: {
    langvalue: function (o, n) {
      if (o != n) {
        this.getDeviceList(1);
      }
    },
  },

  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("user"));
    this.getDeviceList(1);
  },
  methods: {
    handAdddevi(v) {
		console.log('999');
		this.diolg = true
		this.$refs.authtabdiolg.authtabdiolgdata = v
		this.$refs.authtabdiolg.handequipmentList()
		this.$refs.authtabdiolg.centerDialogVisible =true
      // this.titlename = this.$t("devtable.tjmjjz");

    },
    // 查询
    onSubmit() {
      console.log("submit!");
      this.getDeviceList(1);
    },
    // 显示隐藏 查询主体
    handFromshow() {
      this.flag = !this.flag;
    },

    // 点击操作里面的按钮
    handlerow(v, name) {
     if (name == "修改" || name == "Modify") {
        // this.titlename = this.$t("devtable.xgsbt");
        this.handlModify(v);
      }else if (name == "删除" || name == "Delete") {
        this.hanelDelete(v);
      }
    },
	
    // 修改操作
    handlModify(v) {
		console.log('995');
		this.diolgEdit = true
		console.log(this.diolgEdit);
      this.$refs.deviceEdit.handselecList(v.id);
	  this.$refs.deviceEdit.centerDialogVisible =true
	  
      // this.titlename='修改设备'
      // this.$refs.deviadd.dialogFormVisible = true;
    },
    //打开删除界面
    hanelDelete(data) {
      console.log(data);
      this.deldata = data;
      this.$refs.namefrom.dialogname = true;
    },
    //删除关闭事件
    handialogname(data) {
      if (data.name_input != this.UserInfo.user_name_save) {
        this.$message({
          type: "warning",
          message: this.$t("devtable.yhmsryw"),
        });
        return false;
      }

      if (data.pass_input != this.UserInfo.user_pass_save) {
        this.$message({
          type: "warning",
          message: this.$t("devtable.yhmmsryw"),
        });
        return false;
      }
      const params = {
        method: 'co.group.device.del',
        name: data.name_input,
        password: this.$md5(data.pass_input),
        id: this.deldata.id,
        agent_id: this.UserInfo.agent_id,
      };
      this.$serve(params).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: this.$t("devtable.sccg"),
                  center: true,
                  type: "success",
                  duration: 2000,
                  offset: 100,
                });
                this.$refs.namefrom.dialogname = false;
                this.getDeviceList();
              } else {
                //删除失败
                if (res.data.code == -8) {
                  this.$message({
                    message: this.$t("devtable.scsbmyqx"),
                    type: "warning",
                  });
                } else {
                  this.$message({
                    message: this.$t("devtable.scsb"),
                    type: "warning",
                  });
                }
              }
            });
      
      
    },
    // 分页
    handlpages(v) {
      console.log(v);
      this.getDeviceList(v);
    },
    handleSizeChange(val){
      this.getDeviceList(1,val);
    },
    //获取设备列表
    getDeviceList(pageIndex,val) {
      let params = {
        method: "co.group.device.list",
        name: this.formInline.name,
        agent_id: this.UserInfo.agent_id,
        page_index: pageIndex ? pageIndex : 1,
        page_size:val?val: this.configs.pagesize,
      };
      this.$serve(params).then((res) => {
        this.tableData = res.data.data;
        this.configs.total = res.data.count;
        this.tableData.forEach((el) => {
          if (el.unlock_state == 0) {
            el.unlock_state_hint = {
              state: true,
              type: "primary",
              name: this.most.j,
            };
          } else {
            el.unlock_state_hint = {
              state: true,
              type: "primary",
              name: this.most.c,
            };
          }
          if (el.lock_mode == 0)
            el.lock_mode_hint = { state: true, name: this.most.ysms };
          else if (el.lock_mode == 1)
            el.lock_mode_hint = { state: true, name: this.most.ckms };
          else el.lock_mode_hint = { state: true, name: this.most.cbms };

          if (el.support_face == 0)
            el.support_face_hint = { state: true, name: this.most.frlj };
          else el.support_face_hint = { state: true, name: this.most.rlj };

          if (el.device_state == 1) {
            el.device_state_hint = {
              state: true,
              type: "success",
              name: this.most.zx,
            };
          } else {
            el.device_state_hint = {
              state: true,
              type: "warning",
              name: this.most.lx,
            };
          }
          if (el.is_registe == 1) {
            el.is_registe_hint = {
              state: true,
              type: "success",
              name: this.most.s,
            };
          } else {
            el.is_registe_hint = {
              state: true,
              type: "warning",
              name: this.most.f,
            };
          }
        });
      });
    },
    addDeviceSuccess() {
      this.getDeviceList(1);
    },
  },
};
</script>
<style lang="less" scoped>
.devicontent {
  padding: 20px;
  background-color: #fff;
  .dei_rowp {
    display: flex;
    width: 30%;
    .dev_dowm {
      width: 200px;
    }
    .but {
      margin-left: 20px;
      margin-right: 30px;
    }
  }
  .frominput {
    margin-top: 25px;
    margin-left: 20px;
  }
}
.el-dialog__wrapper .el-dialog /deep/ .el-dialog__body {
  padding: 0px 20px 30px 20px !important;
}
.el-dialog__wrapper .el-dialog /deep/ .el-dialog__body .el-form {
  margin-top: 0;
}
</style>
